/// <amd-module name="VSSUI/VssPersona" />
export { VssPersona } from "./Components/VssPersona/VssPersona";

// @NOTE: Explicit export list due to typescript compiler bug 18644 where a require is generated for export * when const enum's are present
export { IIdentityDetailsProvider, IVssPersonaProps, VssPersonaSize } from "./Components/VssPersona/VssPersona.Props";
